import { FC, ReactNode } from 'react';
import { Breadcrumbs } from '@mui/material';
import { StyledLink } from './styles';

interface BreadcrumbsNavigationProps {
  navigationConfig: { name: string | ReactNode; path: string }[];
}

const BreadcrumbsNavigation: FC<BreadcrumbsNavigationProps> = ({ navigationConfig }) => {
  return (
    <Breadcrumbs>
      {navigationConfig.map(({ name, path }) => (
        <StyledLink key={path} to={path} relative="path">
          {name}
        </StyledLink>
      ))}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNavigation;
